export enum ActiveStates {
  Active = 'Active',
  Inactive = 'Inactive'
}
